import React from 'react';
import createReactClass from 'create-react-class';
import PurchaseSuggestionWidget from './PurchaseSuggestionWidget';
import request from '../../helpers/request';
import purchaseSuggestionConfig from './config/purchaseSuggestionConfig';
import sendNotification from '../../helpers/sendNotification';
import setViewTitle from '../../helpers/setViewTitle';
import SubmitButton from '../common/Forms/SubmitButton';
import AjaxInProgressHOC from '../common/AjaxInProgressHOC';

var NewPurchaseSuggestion = createReactClass({

  getInitialState() {
    return {
      lines: [],
      isValid: false,
      itemCount: 0,
      newItemCount: 0,
      orderWithoutStorage: false,
    };
  },

  componentWillMount() {
    setViewTitle('Neuer Bestellvorschlag');
  },

  handleSubmit(formData, documents) {
    const data = this.state.orderWithoutStorage ?
      {
        price: formData.orderSumme
      } :
      {
        lines: formData.lines,
        newLines: formData.newLines
      };
    request.post({
      url: purchaseSuggestionConfig.apiUrl + 'new',
      data: {
        ...data,
        documents,
        orderWithoutStorage: this.state.orderWithoutStorage,
      },
      success: () => {
        sendNotification('Die Buchhaltung wurde über die offene Genehmigung informiert');
        this.props.history.push('/purchasesuggestions/overview');
      }
    });
  },

  handleClearAll() {
    this.suggestions.clear();
  },

  handleListStateChanges(listState) {
    this.setState({
      isValid: listState.isValid,
      itemCount: listState.itemCount,
      newItemCount: listState.newItemCount,
      orderWithoutStorage: listState.orderWithoutStorage,
    });
  },


  render() {
    const disableAll = this.props.isAjaxInProgress || (!this.state.orderWithoutStorage && this.state.itemCount === 0 && this.state.newItemCount === 0);

    const checkBoxStyles = {
      marginLeft: '8px',
      marginTop: '10px',
      marginBottom: '10px',
    };

    const footer = (
      <footer>
        <SubmitButton canSubmit={!disableAll && this.state.isValid} title="Zur Genehmigung senden" />
        {!this.state.orderWithoutStorage &&
          <button type="button" className="btn btn-danger" onClick={this.handleClearAll} disabled={disableAll}>Liste leeren</button>
        }
      </footer>
    );

    const formTitle = this.state.orderWithoutStorage ? 'Neuer Bestellvorschlag ohne Lagerführung' : 'Neuer Bestellvorschlag';

    return (
      <div>
        <div className="row">
          <PurchaseSuggestionWidget
            ref={c => this.suggestions = c}
            dataUrl={purchaseSuggestionConfig.apiUrl + 'new'}
            title={formTitle}
            onChange={this.handleListStateChanges}
            onSubmit={this.handleSubmit}
            footer={footer}
            documentsNodeId="documents-placeholder"
            suggestionId="new"
            claim="purchasesuggestions:new"
            canSwitchOrderWithoutStorage={true}
          />
        </div>
        <div className="row" id="documents-placeholder">
        </div>
        <div className="clearfix"></div>
      </div>
    );
  },

});

export default AjaxInProgressHOC(NewPurchaseSuggestion);



// WEBPACK FOOTER //
// ./src/components/purchasesuggestions/NewPurchaseSuggestion.js